"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PackagesService = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Api = _interopRequireDefault(require("../Api"));
var _excluded = ["token"],
  _excluded2 = ["token"],
  _excluded3 = ["token"],
  _excluded4 = ["token", "id"],
  _excluded5 = ["token"],
  _excluded6 = ["token", "id"],
  _excluded7 = ["token", "id"],
  _excluded8 = ["token"],
  _excluded9 = ["token", "id"],
  _excluded10 = ["token"],
  _excluded11 = ["token"],
  _excluded12 = ["token"],
  _excluded13 = ["token"],
  _excluded14 = ["token"],
  _excluded15 = ["token"],
  _excluded16 = ["token", "tenantId"],
  _excluded17 = ["token", "tenantId"],
  _excluded18 = ["token"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PackagesService = exports.PackagesService = /*#__PURE__*/(0, _createClass2["default"])(function PackagesService() {
  (0, _classCallCheck2["default"])(this, PackagesService);
});
(0, _defineProperty2["default"])(PackagesService, "listPackages", function (_ref) {
  var token = _ref.token,
    params = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return _Api["default"].withAuth(token).get("/incomingPackage", {
    params: params
  });
});
(0, _defineProperty2["default"])(PackagesService, "listPackageMap", function (_ref2) {
  var token = _ref2.token,
    params = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return _Api["default"].withAuth(token).get("/incomingPackage/readyForPickup/byUnit", {
    params: params
  });
});
(0, _defineProperty2["default"])(PackagesService, "listCarriers", function (_ref3) {
  var token = _ref3.token,
    params = (0, _objectWithoutProperties2["default"])(_ref3, _excluded3);
  return _Api["default"].withAuth(token).get('/carrier', {
    params: params
  });
});
(0, _defineProperty2["default"])(PackagesService, "getPackageById", function (_ref4) {
  var token = _ref4.token,
    id = _ref4.id;
  return _Api["default"].withAuth(token).get("/incomingPackage/".concat(id));
});
(0, _defineProperty2["default"])(PackagesService, "deletePackage", function (_ref5) {
  var token = _ref5.token,
    id = _ref5.id;
  return _Api["default"].withAuth(token)["delete"]("/incomingPackage/".concat(id));
});
(0, _defineProperty2["default"])(PackagesService, "changePackageLocation", function (_ref6) {
  var token = _ref6.token,
    id = _ref6.id,
    params = (0, _objectWithoutProperties2["default"])(_ref6, _excluded4);
  return _Api["default"].withAuth(token).post("/incomingPackage/".concat(id, "/changeLocation"), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(PackagesService, "createPackageBatch", function (_ref7) {
  var token = _ref7.token,
    params = (0, _objectWithoutProperties2["default"])(_ref7, _excluded5);
  return _Api["default"].withAuth(token).post("/incomingPackage/batch", _objectSpread({}, params));
});
(0, _defineProperty2["default"])(PackagesService, "changePackageCarrier", function (_ref8) {
  var token = _ref8.token,
    id = _ref8.id,
    params = (0, _objectWithoutProperties2["default"])(_ref8, _excluded6);
  return _Api["default"].withAuth(token).post("/package/".concat(id, "/changeCarrier"), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(PackagesService, "patchPackage", function (_ref9) {
  var token = _ref9.token,
    id = _ref9.id,
    params = (0, _objectWithoutProperties2["default"])(_ref9, _excluded7);
  return _Api["default"].withAuth(token).patch("/package/".concat(id), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(PackagesService, "listLocations", function (_ref10) {
  var token = _ref10.token,
    params = (0, _objectWithoutProperties2["default"])(_ref10, _excluded8);
  return _Api["default"].withAuth(token).get("/location", {
    params: params
  });
});
(0, _defineProperty2["default"])(PackagesService, "listPackageTimeline", function (_ref11) {
  var token = _ref11.token,
    id = _ref11.id,
    params = (0, _objectWithoutProperties2["default"])(_ref11, _excluded9);
  return _Api["default"].withAuth(token).get("/incomingPackage/".concat(id, "/timeline"), {
    params: params
  });
});
(0, _defineProperty2["default"])(PackagesService, "createPackageLocation", function (_ref12) {
  var token = _ref12.token,
    params = (0, _objectWithoutProperties2["default"])(_ref12, _excluded10);
  return _Api["default"].withAuth(token).post("/location", _objectSpread({}, params));
});
(0, _defineProperty2["default"])(PackagesService, "deletePackageLocation", function (_ref13) {
  var token = _ref13.token,
    id = _ref13.id;
  return _Api["default"].withAuth(token)["delete"]("/location/".concat(id));
});
(0, _defineProperty2["default"])(PackagesService, "returnPackage", function (_ref14) {
  var token = _ref14.token,
    params = (0, _objectWithoutProperties2["default"])(_ref14, _excluded11);
  return _Api["default"].withAuth(token).post("/incomingPackage/return", null, {
    params: params
  });
});
(0, _defineProperty2["default"])(PackagesService, "undoReturnPackage", function (_ref15) {
  var token = _ref15.token,
    id = _ref15.id;
  return _Api["default"].withAuth(token).post("/incomingPackage/".concat(id, "/undoReturn"));
});
(0, _defineProperty2["default"])(PackagesService, "forceDelivery", function (_ref16) {
  var token = _ref16.token,
    params = (0, _objectWithoutProperties2["default"])(_ref16, _excluded12);
  return _Api["default"].withAuth(token).post("/incomingPackage/forcePickup", null, {
    params: params
  });
});
(0, _defineProperty2["default"])(PackagesService, "incomingPackagesByCarrier", function (_ref17) {
  var token = _ref17.token,
    params = (0, _objectWithoutProperties2["default"])(_ref17, _excluded13);
  return _Api["default"].withAuth(token).get('/dashboard/incomingPackage/byCarrier', {
    params: params
  });
});
(0, _defineProperty2["default"])(PackagesService, "incomingPackagesByDay", function (_ref18) {
  var token = _ref18.token,
    params = (0, _objectWithoutProperties2["default"])(_ref18, _excluded14);
  return _Api["default"].withAuth(token).get('/dashboard/incomingPackage/byDay', {
    params: params
  });
});
(0, _defineProperty2["default"])(PackagesService, "incomingPackagesByState", function (_ref19) {
  var token = _ref19.token,
    params = (0, _objectWithoutProperties2["default"])(_ref19, _excluded15);
  return _Api["default"].withAuth(token).get('/dashboard/incomingPackage/byState', {
    params: params
  });
});
(0, _defineProperty2["default"])(PackagesService, "listIncomingPackageOvertimeFilters", function (_ref20) {
  var token = _ref20.token,
    tenantId = _ref20.tenantId,
    params = (0, _objectWithoutProperties2["default"])(_ref20, _excluded16);
  return _Api["default"].withAuth(token, tenantId).get("/management/incomingPackage/overtimeFilters", {
    params: params
  });
});
(0, _defineProperty2["default"])(PackagesService, "setIncomingPackageInClearOvertime", function (_ref21) {
  var token = _ref21.token,
    tenantId = _ref21.tenantId,
    params = (0, _objectWithoutProperties2["default"])(_ref21, _excluded17);
  return _Api["default"].withAuth(token, tenantId).post("/management/incomingPackage/clearOvertime", null, {
    params: params
  });
});
(0, _defineProperty2["default"])(PackagesService, "setIncomingPackageInWaitingResident", function (_ref22) {
  var token = _ref22.token,
    params = (0, _objectWithoutProperties2["default"])(_ref22, _excluded18);
  return _Api["default"].withAuth(token).post("/incomingPackage/waitPickup", null, {
    params: params
  });
});